const AppointmentReport = () => {
    return (
        <div>
            <h1>Appointment Report</h1>
        </div>
    );
};

export default AppointmentReport;